import React from "react";
import { Search } from "lucide-react";

const TableHeader = ({
  searchQuery,
  onSearch,
  onCreate,
  placeholder = "Search...",
  createLabel = "+ Create",
  totalRecords = 0,
  startIndex = 0,
  endIndex = 0,

  // NEW
  rowsPerPage = 20,
  onPageSizeChange,
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3 mb-3">
      {/* LEFT */}
      <div className="flex items-center gap-3">
        <div className="relative">
          <Search className="absolute left-2 top-2.5 text-gray-400" size={16} />
          <input
            type="text"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => onSearch(e.target.value)}
            className="pl-8 pr-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-1 focus:ring-gray-300"
          />
        </div>
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-4">
        {/* RECORD COUNT */}
        <span className="text-sm text-gray-500">
          {totalRecords > 0
            ? `${startIndex}-${endIndex} of ${totalRecords}`
            : "0 records"}
        </span>

        {/* PAGE SIZE */}
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600">Rows:</span>
          <select
            value={rowsPerPage}
            onChange={(e) => onPageSizeChange(Number(e.target.value))}
            className="px-2 py-1 border rounded-md text-sm"
          >
            {[10, 20, 50, 100].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>

        {/* CREATE BUTTON */}
        {onCreate && (
          <button
            onClick={onCreate}
            className="bg-gradient-to-r from-[#0061A4] to-[#00ACED] text-white text-sm font-medium px-4 py-2 rounded-md"
          >
            {createLabel}
          </button>
        )}
      </div>
    </div>
  );
};

export default TableHeader;
